import { render, staticRenderFns } from "./LossTableConfigurationModal.vue?vue&type=template&id=c5a885d6&scoped=true&"
import script from "./LossTableConfigurationModal.vue?vue&type=script&lang=ts&"
export * from "./LossTableConfigurationModal.vue?vue&type=script&lang=ts&"
import style0 from "./LossTableConfigurationModal.vue?vue&type=style&index=0&id=c5a885d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a885d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5a885d6')) {
      api.createRecord('c5a885d6', component.options)
    } else {
      api.reload('c5a885d6', component.options)
    }
    module.hot.accept("./LossTableConfigurationModal.vue?vue&type=template&id=c5a885d6&scoped=true&", function () {
      api.rerender('c5a885d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LossTableConfigurationModal/LossTableConfigurationModal.vue"
export default component.exports